import {useState} from 'react'
import useEmployees from '../../../../common/hooks/useEmployees'
import {Employee} from '../../core/entities/employee'
import {Sort} from '../../core/entities/sort'
import avatarPlaceholder from 'assets/avatar-placeholder.svg'
import filterEmployees from './utils/filterEmployees'
import sortEmployees from './utils/sortEmployees'

type QRModalOptions = {
    qrId: number
    name: string
    role: string
}

type DeleteModalOptions = {
    id: number
    name: string
    role: string
    photo: string
    qrId: number
}

const useEmployeesQRPage = () => {
    const {data: employeesData, isLoading} = useEmployees()
    const [filterBy, setFilterBy] = useState<string>('')
    const [sortBy, setSortBy] = useState<Sort | null>(null)

    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [editModalInitialData, setEditModalInitialData] =
        useState<Employee | null>(null)

    const [qrModalOptions, setQRModalOptions] = useState<QRModalOptions | null>(
        null,
    )

    const [deleteModalOptions, setDeleteModalOptions] =
        useState<DeleteModalOptions | null>(null)

    const {ids, map} = employeesData || {ids: [], map: {}}

    const openEditModalWithData = (p: Employee) => {
        setIsEditModalOpen(true)
        setEditModalInitialData(p)
    }
    const openEditModal = () => setIsEditModalOpen(true)
    const closeEditModal = () => {
        setIsEditModalOpen(false)
        setEditModalInitialData(null)
    }

    const onFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilterBy(e.target.value)
    }

    const onSort = (f: Sort) => {
        setSortBy(f)
    }

    const onOpenQRModal = ({qrId, firstName, role}: Employee) =>
        setQRModalOptions({
            qrId,
            role,
            name: firstName,
        })

    const onCloseQRModal = () => setQRModalOptions(null)

    const onOpenDeleteModal = ({
        id,
        avatar,
        firstName,
        lastName,
        role,
        qrId,
    }: Employee) =>
        setDeleteModalOptions({
            id,
            role,
            name: `${firstName} ${lastName}`,
            photo: avatar || avatarPlaceholder,
            qrId,
        })
    const onCloseDeleteModal = () => setDeleteModalOptions(null)

    const filteredIds = filterBy
        ? filterEmployees({ids, map, filterBy})
        : [...ids]

    const filteredAndSortedIds = sortBy
        ? sortEmployees({ids: filteredIds, map, sortBy})
        : filteredIds

    return {
        data: {
            isLoading,
            map,
            filteredAndSortedIds,
        },
        filter: {
            filterBy,
            onFilter,
        },
        sort: {
            sortBy,
            onSort,
        },
        editModal: {
            isEditModalOpen,
            editModalInitialData,
            openEditModalWithData,
            openEditModal,
            closeEditModal,
        },
        qrModal: {
            qrModalOptions,
            onOpenQRModal,
            onCloseQRModal,
        },
        deleteModal: {
            deleteModalOptions,
            onOpenDeleteModal,
            onCloseDeleteModal,
        },
    }
}

export default useEmployeesQRPage
